<div *ngIf="form">
  <div class="flex space-x-4">
    <app-input [type]="'text'" [control]="form.get('name')" [label]="'customField.name' | translate" [placeholder]="'customField.name' | translate" class="w-1/2 pr-2" data-test="orgCustomName"></app-input>
    <app-input [control]="form.get('alias')" (change)="aliasChangeEvent.emit()" [label]="'organizationData.alias' | translate" [placeholder]="'organizationData.aliasPlaceholder' | translate" class="w-1/2" data-test="orgCustomAlias"></app-input>
  </div>

  <app-custom-fields [conf]="{ form: form, onSubmit: conf.onSubmit, data: conf.data.customFields, permissions: conf.permissions }" [type]="'custom'" [scope]="customFieldsScope"></app-custom-fields>

</div>
